__turbopack_context__.v({
  "borderlessReadonly": "rilWqa_borderlessReadonly",
});
